export enum WarehouseInventoryv2MenuEnum {
    overview = 0,
    unitSizeWise,
    project,
    landprices,
    propertyTransaction
}
